import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import TableList from '../../components/TableList';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { CheckBox } from '../../components/checkboxes/check-box';
import { Popup } from '../../components/Popup/popup';
import { AppSettings } from '../../constants';
import * as UnitHelper from '../../helper/unit-helper';
import * as RequestTypePolicyActionType from '../constants';
import AddEditRequestType from '../Components/add-edit-request-type';
import '../request-type.css';
import Translate from 'components/translate';

const defaultParams = {
  defaultSortName: 'type',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

const TABLE_NAME = 'REQUEST_TYPE_LIST';

class ManageRequestTypes extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    RequestTypeStore: PropTypes.object,
    PageSizeReference: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.RequestTypeStore.ManageRequestTypes.params.take
    );

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.RequestTypeStore.ManageRequestTypes.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord: props.RequestTypeStore.ManageRequestTypes.params.totalRecord,
      data: props.RequestTypeStore.ManageRequestTypes.items,
      status: props.RequestTypeStore.ManageRequestTypes.params.status,
      isShowPopup: false,
      checkedValues: ['active', 'inActive'],
      isOpenModal: false
    };
  }

  componentDidMount() {
    this.binding(this.objToParams({ ...this.props.RequestTypeStore.ManageRequestTypes.params, take: this.state.sizePerPage}));

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.RequestTypeStore.ManageRequestTypes) {
      this.setState({
        totalRecord:
          nextProps.RequestTypeStore.ManageRequestTypes.params.totalRecord,
        data: nextProps.RequestTypeStore.ManageRequestTypes.items,
        status: nextProps.RequestTypeStore.ManageRequestTypes.params.status,
        currentPage: nextProps.RequestTypeStore.ManageRequestTypes.params.skip
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RequestTypePolicyActionType.RESET_REQUEST_TYPE,
      params: null
    });
  }

  customRenderName(item) {
    return <span>{item.name}</span>;
  }

  customRenderType(item) {
    return (
      <span>{item.type === 0 || item.type === 2 || item.type === 3 ? 'Warranty request' : <Translate translateKey='punchlist' capitalize/>}</span>
    );
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  trClassFormat = row => {
    if (row && row.status === 0) {
      return 'colm-inactive';
    }
    return '';
  };

  binding(params) {
    this.props.dispatch({
      type: RequestTypePolicyActionType.SEARCH_REQUEST_TYPE_ASYNC,
      params: params
    });
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: 'Edit',
        icon: 'glyphicon glyphicon-pencil',
        event: this.onOpenAddEditPopup
      }
    ];

    if (item.status) {
      contextItem.push({
        title: 'Make inactive',
        icon: 'glyphicon glyphicon-minus-sign',
        event: this.onMakeInActive
      });
    } else {
      contextItem.push({
        title: 'Make active',
        icon: 'glyphicon glyphicon-ok-sign',
        event: this.onMakeActive
      });
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onViewAssociatedItemsToRepair(e, item) {
    this.props.history.push(`/items/${item.name}`);
  }

  onMakeInActive = (e, item) => {
    this.onSave(item.id, RequestTypePolicyActionType.MAKE_INACTIVE_REQUEST_TYPE_ASYNC);
  }

  onMakeActive = (e, item) => {
    this.onSave(item.id, RequestTypePolicyActionType.MAKE_ACTIVE_REQUEST_TYPE_ASYNC);
  }

  onTableBinding(configTable) {
    var params = this.objToParams(
      this.props.RequestTypeStore.ManageRequestTypes.params
    );
    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onSave(data, requestTypePolicyActionType, callback) {
    var params = {
      ...this.objToParams(this.props.RequestTypeStore.ManageRequestTypes.params),
      //skip: 0,
      totalRecord: 0,
      totalPages: 0,
      name: this.search.value.trim() //$('#txt-search-name').val()
    };

    this.props.dispatch({
      type: requestTypePolicyActionType,
      params: {
        data: data,
        search: params
      },
      callback
    });
  }

  onOpenAddEditPopup = (e, item) => {
    this.setState({isOpenModal: true, requestTypeId: item ? item.id : null });
  }

  onCloseModal = () => {
    this.setState({ isOpenModal: false });
    // this.props.dispatch({
    //   type: RequestTypePolicyActionType.CLOSE_FORM_CREATE_REQUEST_TYPE,
    //   params: null
    // });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value).sort()
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value].sort()
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  }

  onSearch() {
    var params = this.objToParams(
      this.props.RequestTypeStore.ManageRequestTypes.params
    );

    this.setState({
      checkedValues: ['active', 'inActive']
    });

    this.binding({
      ...params,
      status: 'all',
      skip: 0
    });
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? '' : data.toString();
    if (status !== '') {
      var params = this.objToParams(
        this.props.RequestTypeStore.ManageRequestTypes.params
      );
      if (status.includes('active,inActive')) {
        status = 'all';
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    } else {
      this.setState({ data: [] });
    }
  }

  // onPreOrientation(e, item, data, state) {
  //   const { fromHomeOwner } = item;
  //   if (state.checked) {
  //     this.onSave(
  //       e,
  //       state.value,
  //       RequestTypePolicyActionType.CHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC,
  //       isSuccess => {
  //         if (isSuccess && fromHomeOwner) {
  //           this.onSave(
  //             e,
  //             state.value,
  //             RequestTypePolicyActionType.UNCHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC
  //           );
  //         }
  //       }
  //     );
  //   } else {
  //     this.onSave(
  //       e,
  //       state.value,
  //       RequestTypePolicyActionType.UNCHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC
  //     );
  //   }
  // }

  // onFromHomeOwner(e, item, data, state) {
  //   const { preOrientation } = item;
  //   if (state.checked) {
  //     this.onSave(
  //       e,
  //       state.value,
  //       RequestTypePolicyActionType.CHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC,
  //       isSuccess => {
  //         if (isSuccess && preOrientation) {
  //           this.onSave(
  //             e,
  //             state.value,
  //             RequestTypePolicyActionType.UNCHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC
  //           );
  //         }
  //       }
  //     );
  //   } else {
  //     this.onSave(
  //       e,
  //       state.value,
  //       RequestTypePolicyActionType.UNCHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC
  //     );
  //   }
  // }

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(), // $('#txt-search-name').val(),
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: RequestTypePolicyActionType.SEARCH_REQUEST_TYPE_ASYNC,
          params: {
            searchKey: this.search.value.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  render() {
    const column = [
      {
        field: 'id',
        header: 'id',
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'name',
        header: 'Name',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'type',
        header: 'Type',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left',
        customRender: this.customRenderType.bind(this)
      },
      {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this),
        className: 'column-action',
        columnClassName: 'column-action'
      }
    ];

    const { data } = this.state;
    const totalRecord = data.length > 0 ? this.state.totalRecord : 0;
    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: totalRecord
    };
    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='box-search'>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  ref={ref => {
                    this.search = ref;
                  }}
                  className='form-control'
                  placeholder='Search'
                  onKeyPress={this.onEnter.bind(this)}
                />
                <span className='input-group-btn'>
                  <button
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'
                  >
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>
            <div className='manage-user-filter pull-right'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
              />

              {this.state.isShowPopup && (
                <Popup ref={ref => { his.popup = ref; }}>
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange}
                  />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange}
                  />
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Request types ({totalRecord})</h2>
          <button
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            onClick={this.onOpenAddEditPopup.bind(this)}>
            <span className='fa fa-plus icon' />NEW
          </button>
        </div>

        {
          this.state.isOpenModal &&
          <AddEditRequestType
            requestTypeId={this.state.requestTypeId}
            onSubmit={this.onSave.bind(this)}
            onCloseModal={this.onCloseModal}/>
        }

        <TableList
          ref={ref => { this.tableList = ref; }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
          trClassName={this.trClassFormat}
        />
        <ContextMenu ref={ref => { this.cxtMenu = ref; }} />
        <MessengerBox ref={ref => { this.msgBox = ref; }} title={AppSettings.COMPANY_NAME} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    PageSizeReference: state.BuilderStore.PageSizeReference,
    RequestTypeStore: state.RequestTypeStore
  };
};

export default connect(mapStateToProps)(ManageRequestTypes);



// WEBPACK FOOTER //
// ./src/Request-Types/Containers/manage-request-type.js